import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
export var errorMiddleware = function errorMiddleware() {
  return function (next) {
    return function (action) {
      // If not a promise, continue on
      if (Promise.resolve(action.payload) !== action.payload) {
        return next(action);
      } // Dispatch initial pending promise, but catch any errors


      return next(action)["catch"](function (error) {
        console.warn(error);
        return error;
      });
    };
  };
};